/**
 * GemPages AJAX Add-to-Cart -> Warehouse mini-cart drawer (2026-08-11)
 *
 * GemPages (v6) "Add To Cart" buttons are published with data-cbto="cart",
 * which hard-redirects to /cart after adding. There is no global GemPages
 * setting to change this, and each template would need editing + republishing.
 *
 * This script intercepts those clicks in the capture phase (before GemPages'
 * own jQuery handler runs), adds the item via /cart/add.js, and dispatches the
 * theme's "product:added" event. The Warehouse header listens for that event
 * at the document level: it refreshes the mini-cart section and slides open
 * the cart drawer (theme cartType is "drawer"), showing the updated count.
 *
 * Buttons with data-cbto="checkout" (Buy Now) are left untouched.
 * Remove this file + its include in layout/theme.liquid to restore the
 * original redirect behavior.
 *
 * 2026-10-06 (cart lane): on layout/theme.landing.liquid (ad landing pages,
 * no mini-cart drawer markup) this file is also loaded, with
 * window.__clAjaxCartRedirectToCart set true. In that mode, after a
 * successful AJAX add we redirect to /cart instead of opening a drawer -
 * this preserves the original data-cbto="cart" hard-redirect UX. We hold the
 * redirect for up to REDIRECT_HOLD_MS (or until cl-klaviyo-atc.liquid signals
 * 'cl:atc-tracked') so the Klaviyo Added to Cart event has a real chance to
 * reach klaviyo.js before the page unloads and destroys window._learnq.
 */
(function () {
  var BUSY_ATTR = 'data-gem-ajax-busy';
  var REDIRECT_HOLD_MS = 900; // generous but bounded wait for klaviyo.js to flush

  /** Redirects to /cart, but gives Klaviyo ATC tracking a bounded head start. */
  function redirectToCartAfterTracking() {
    var done = false;
    function go() {
      if (done) return;
      done = true;
      window.location.href = '/cart';
    }
    document.addEventListener('cl:atc-tracked', go, { once: true });
    setTimeout(go, REDIRECT_HOLD_MS);
  }

  /** Finds the GemPages module wrapper that carries the button config. */
  function findModule(button) {
    var node = button.parentElement;
    while (node && node !== document.body) {
      if (node.hasAttribute('data-cbto')) return node;
      node = node.parentElement;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('.gf_add-to-cart');
    if (!button) return;
    var form = button.closest('form[action*="/cart/add"]');
    if (!form) return;
    var module = findModule(button);
    var target = module ? module.getAttribute('data-cbto') : 'cart';
    if (target === 'checkout') return; // preserve Buy Now behavior

    event.preventDefault();
    event.stopImmediatePropagation(); // block GemPages' redirect handler

    if (button.hasAttribute(BUSY_ATTR)) return;
    button.setAttribute(BUSY_ATTR, '1');

    var originalHtml = button.innerHTML;
    var addingText = (module && module.getAttribute('data-ajaxtext')) || 'Adding...';
    var addedText = (module && module.getAttribute('data-thankyoutext')) || 'Added!';
    button.innerHTML = addingText;

    function restore(delayMs) {
      setTimeout(function () {
        button.innerHTML = originalHtml;
        button.removeAttribute(BUSY_ATTR);
      }, delayMs);
    }

    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.append('quantity', '1');
    var quantity = parseInt(formData.get('quantity'), 10) || 1;

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
          return data;
        });
      })
      .then(function (data) {
        button.innerHTML = addedText;
        // Warehouse header: refreshes mini-cart HTML and opens the drawer.
        // `data` is the /cart/add.js line item (id/variant_id, product_id,
        // price, etc.) - pass it through so listeners (Klaviyo ATC tracking)
        // know exactly which variant was added instead of guessing.
        form.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: data, quantity: quantity }
        }));
        if (window.__clAjaxCartRedirectToCart) {
          // Landing-page mode: preserve the original hard-redirect UX, but
          // hold it briefly so tracking isn't destroyed by the navigation.
          redirectToCartAfterTracking();
          return;
        }
        // Keep standalone count bubbles in sync (same as legacy inline snippet).
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var counters = document.querySelectorAll('[data-cart-count]');
            for (var i = 0; i < counters.length; i++) {
              counters[i].innerHTML = cart.item_count;
            }
          });
        restore(2000);
      })
      .catch(function (error) {
        button.innerHTML = (error && error.message) || 'Error - try again';
        restore(3000);
      });
  }, true);
})();
